import { Toast as BaseToast } from '@base-ui/react/toast';

import type { FC } from 'react';

import { toastManager } from '@/lib/notify';

import { ToastItem } from '../ToastItem';

import type { TToastProviderProps } from './Toast.props';

const DEFAULT_TIMEOUT_MS = 5000;

const ToastList: FC = () => {
  const { toasts } = BaseToast.useToastManager();

  return (
    <>
      {toasts.map(toast => <ToastItem key={toast.id} toast={toast} />)}
    </>
  );
};

const ToastProvider: FC<TToastProviderProps> = ({ children, timeout = DEFAULT_TIMEOUT_MS }) => (
  <BaseToast.Provider timeout={timeout} toastManager={toastManager}>
    {children}
    <BaseToast.Portal>
      <BaseToast.Viewport className="fixed top-6 left-1/2 z-50 flex w-max max-w-96 -translate-x-1/2 flex-col gap-2">
        <ToastList />
      </BaseToast.Viewport>
    </BaseToast.Portal>
  </BaseToast.Provider>
);

const useToast = BaseToast.useToastManager;

export {
  ToastProvider,
  useToast,
};
